export const ESTABLISHMENT = 'establishment'
export const PREMISE = 'premise'
export const SUBPREMISE = 'subpremise'

export const SUPPORTED_GOOGLE_PLACE_TYPES = [ESTABLISHMENT, PREMISE, SUBPREMISE]
